import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'documentCheckEditPipe'
})
export class DocumentCheckEditPipe implements PipeTransform {

  transform(dataItem: any, canSuperEdit: boolean,canEdit:boolean,memberName:string,canSuperEditApprovedDocuments: boolean,createdOn:Date,projectId:number): boolean {
    const createdDate = new Date(createdOn);
    const daysToCompare = Math.ceil((new Date().getTime() - createdDate.getTime()) / (1000 * 60 * 60 * 24))
    if(canSuperEditApprovedDocuments && daysToCompare<=30 && projectId==1)
    {
      return true;
    }
    else if (canSuperEdit && dataItem.trans_type != 'Approved') {
      return true
    }
    else if (canEdit && dataItem.trans_type != 'Approved') {
      if (dataItem.createdBy === memberName) {
        return true;
      }
      else  return false;
    }
    else {
      return false;
    }
    
  }

}
